module.exports = __webpack_public_path__ + "media/file4.mp4";